module.exports = __webpack_public_path__ + "static/desktop/img/step-en.3b44ae18.jpeg";